export default {
    "GameName": "Gods of Zushin",
    "ChapterName": "Chapter 3 - Awakening of Darkness",
    "fbLink": "http://facebook.com/godsofzushin",
    "ytLink": "https://www.youtube.com/user/GodsOfZushin/videos",
    "Buttons": [
        {
            "type": "Important",
            "text": "Download & Play",
            "href": "https://docs.google.com/document/d/1mvPMAOHOBTAn6p8UHlysO5Yvr3vkhhETp1irhvVaKhg/edit?usp=sharing",
            "classNames": "is-download game-site"
        },
        {
            "type": "Normal",
            "text": "Login",
            "href": "http://goz.fun/page/login",
            "classNames": "game-login"
        },
        {
            "type": "Normal",
            "text": "Register",
            "href": "http://goz.fun/page/register",
            "classNames": "game-register"
        },
        {
            "type": "Normal",
            "text": "GOZ Site",
            "href": "http://goz.fun",
            "classNames": "game-site"
        }
    ],
    "Races": {
        "Title": "",
        "RacesList": [
            {
                "Name": "Swordsman",
                "shortName": "SM",
                "smallDescription": "A class that can damage anything!"
            },
            {
                "Name": "Bead Fairy",
                "shortName": "BF",
                "smallDescription": "A class that can heal and damage!"
            },
            {
                "Name": "Sun Warrior",
                "shortName": "SW",
                "smallDescription": "A class that able to tank and damage as a punisher with a balance!"
            },
            {
                "Name": "Moon Maiden",
                "shortName": "MM",
                "smallDescription": "A class that can tank and damage as punisher with a balance!"
            },
            {
                "Name": "Summoner",
                "shortName": "SMM",
                "smallDescription": "A class that can summon the strongest demons of hell!"
            }
        ]
    },
    "Gift": {
        "Title": "Have awesome beginning with a gift!",
        "RedeemButton": "Download and Redeem in game!",
        "Code": "GKBL056",
        "link": "http://goz.fun/",
        "ItemsList": [
            {
                "ItemName": "Lighting Wing (7 Days)",
                "Amount": "1"
            },
            {
                "ItemName": "React Item PD/MD or Attack",
                "Amount": "8"
            },
            {
                "ItemName": "Epic Zushin Coin",
                "Amount": "1"
            },
            {
                "ItemName": "Inner Zushin Coin",
                "Amount": "5"
            },
            {
                "ItemName": "Tear Zushin Coin",
                "Amount": "10"
            },
            {
                "ItemName": "All New Dungeons Plates",
                "Amount": "2"
            },
            {
                "ItemName": "Namble Water",
                "Amount": "1"
            },
            {
                "ItemName": "Mystic Eye Level 180",
                "Amount": "1"
            },
            {
                "ItemName": "Mystic Stones I",
                "Amount": "60"
            },
            {
                "ItemName": "Pet Spell Bolus",
                "Amount": "300"
            },
            {
                "ItemName": "Bone Bags (4 Million)",
                "Amount": "400"
            },
            {
                "ItemName": "Greater Defensive Spars",
                "Amount": "400"
            },
            {
                "ItemName": "Greater Attacking Spars",
                "Amount": "200"
            },
            {
                "ItemName": "Golden Strikers",
                "Amount": "20"
            },
            {
                "ItemName": "Faction Contribute Tokens",
                "Amount": "20"
            },
            {
                "ItemName": "Cursed Stone V",
                "Amount": "30"
            }
        ]
    },
    "Features": {
        "NewTitle": "Few New Features",
        "OldTitle": "Few Old Features",
        "New": [
            {
                "Title": "Balrog Temple!"
            },
            {
                "Title": "House of Gods!"
            },
            {
                "Title": "Las Noches!"
            },
            {
                "Title": "CT New Benefits!"
            },
            {
                "Title": "New Ambers Shop!"
            },
            {
                "Title": "New Epic Battle & Herbs Shop!"
            },
            {
                "Title": "New Gathering Life Shop!"
            },
            {
                "Title": "New Precuous Items Shop!"
            },
            {
                "Title": "New Recipes Shop!"
            },
            {
                "Title": "New Epic Trinkets Shop!"
            },
            {
                "Title": "New Sign In Event Shop!"
            },
            {
                "Title": "Upgrade on Pet Food Exchange!"
            },
            {
                "Title": "New Drops across all bosses!"
            }
        ],
        "Old": [
            {
                "Title": "Akuma of Zushin - God of Demons"
            },
            {
                "Title": "Litch - Queen of Chaos"
            },
            {
                "Title": "Dragon Lord"
            },
            {
                "Title": "Flame Ruins"
            },
            {
                "Title": "Total Gold Exchange Gift"
            },
            {
                "Title": "New Curency - Zushin Coin"
            },
            {
                "Title": "Faction Contribute Shop"
            },
            {
                "Title": "Guild Contribute Shop"
            },
            {
                "Title": "Special Titles Shop"
            },
            {
                "Title": "Daily Refining Material Gifts"
            },
            {
                "Title": "Daily Bones Gifts"
            }
        ]
    },
    "Footer": {
        "Title": "",
        "FooterLinks": [
            {
                "href": "http://goz.fun/page/tc/conditions",
                "text": "T & C"
            },
            {
                "href": "http://goz.fun/page/tc/policy",
                "text": "Policy"
            },
            {
                "href": "http://facebook.com/godsofzushin/",
                "text": "Contact us"
            },
            {
                "href": "http://goz.fun/page/buy",
                "text": "Charge Zushin Points"
            },
        ]
    },
    "CallAction": {
        "Button": "Start Now!",
        "href": "http://goz.fun"
    }
}


// WEBPACK FOOTER //
// ./src/Resources/Text.js